import { graphql, useStaticQuery } from 'gatsby'

const useRecaptcha = () => {
  const query = useStaticQuery(
    graphql`
      query QueryRecaptchaSiteKey {
        site {
          siteMetadata {
            recaptcha
          }
        }
      }
    `,
  )
  const { recaptcha } = query.site.siteMetadata
  return recaptcha
}

export default useRecaptcha
